import { parsePhoneNumberFromString } from "libphonenumber-js";

/**
 * ISO 3166-1 alpha-2 → emoji bandera (indicadores regionales Unicode).
 */
function countryCodeToFlagEmoji(iso2) {
  if (!iso2 || typeof iso2 !== "string" || iso2.length !== 2) return null;
  const upper = iso2.toUpperCase();
  if (!/^[A-Z]{2}$/.test(upper)) return null;
  const base = 0x1f1e6;
  return [...upper].map((c) => String.fromCodePoint(base + (c.charCodeAt(0) - 65))).join("");
}

/**
 * Dígitos del número o JID WhatsApp (sin sufijo @…).
 */
export function extractPhoneDigits(raw) {
  if (raw == null) return "";
  let s = String(raw).trim();
  const at = s.indexOf("@");
  if (at > 0) s = s.slice(0, at);
  return s.replace(/\D/g, "");
}

/**
 * Bandera + texto para tooltip si el contacto es un número individual válido.
 * Grupos (@g.us), LID, comunidades u otros JIDs → null.
 *
 * @returns {{ flag: string, countryName: string } | null}
 * @param {string} [locale] — p. ej. `i18n.language` (`es`, `pt-BR`, …) para el nombre del país en el tooltip
 */
export function getContactCountryFlagInfo(contact, ticket, locale = "es") {
  if (!contact) return null;
  if (contact.isGroup === true) return null;
  if (ticket && ticket.isGroup === true) return null;

  const raw = contact.number;
  if (!raw || typeof raw !== "string") return null;

  const lower = raw.toLowerCase();
  if (lower.includes("@g.us")) return null;
  if (lower.includes("@lid")) return null;

  const digits = extractPhoneDigits(raw);
  if (digits.length < 8 || digits.length > 15) return null;

  try {
    const parsed = parsePhoneNumberFromString(`+${digits}`);
    if (!parsed || !parsed.isValid()) return null;
    const country = parsed.country;
    if (!country) return null;
    const flag = countryCodeToFlagEmoji(country);
    if (!flag) return null;
    let countryName = country;
    try {
      const loc =
        typeof locale === "string" && locale.length >= 2
          ? locale.replace("_", "-").slice(0, 5)
          : "es";
      const dn = new Intl.DisplayNames([loc], { type: "region" });
      countryName = dn.of(country) || country;
    } catch {
      /* noop */
    }
    return { flag, countryName };
  } catch {
    return null;
  }
}
